import { Component, input, output } from '@angular/core';
import { StepGuide, StepGuideId } from '@maximizer/outlook/shared/data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';

@Component({
  selector: 'maximizer-outlook-onboarding-step-guide',
  templateUrl: './step-guide.component.html',
  imports: [KENDO_BUTTON, TranslatePipe],
})
export class StepGuideComponent {
  exit = output<StepGuideId>();
  next = output<number>();
  skip = output<StepGuideId>();

  onboardingStep = input(1);
  guide = input<StepGuide>({
    stepId: StepGuideId.AddContact1,
    guide: {
      step: 1,
      total: 1,
    },
    title: '',
    content: '',
    hideStepCount: false,
  });
}
